import React, { Component, createRef  } from 'react';
import {
    Input,
    Label,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

class TSText extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            name: props.name,
            type: (props.type != null) ? props.type : 'text',
            maxLength: (props.maxLength !== "undefined") ? props.maxLength : null,
            placeholder: props.placeholder,
            value: (props.value != null) ? props.value : '',
            isFocus: false,
            isReadOnly: (props.isReadOnly != null) ? props.isReadOnly : false,
            icon: props.icon,
            invalid: (props.invalid !== "undefined") ? props.invalid : null,
            require: props.require,
            fontSize: (props.fontSize !== "undefined") ? props.fontSize : '1.2em',
            background: (props.fontSize !== "undefined") ? props.background : 'transparent',
        };

        this.setFocus = this.setFocus.bind(this);
        //this.handleChange = this.handleChange.bind(this);
    }
    
    //parent set ค่า ให้ child เปลี่ยนตาม
    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value });
        }

        if (this.props.invalid !== prevProps.invalid) {
            if (this.state.require) {
                this.setState({ invalid: this.props.invalid });
                this.setState({ isFocus: this.props.invalid });
            }
        }
        
    }

    setFocus(e) {
        this.setState(state => ({
            isFocus: e
        }));

    }

    handleChange = event => {
        this.setState({ value: event.target.value });

        if (this.state.require) {
            this.setState({ invalid: (!!!event.target.value) });
            this.setState({ isFocus: (!!!event.target.value) });
        }
       


        if (this.props.onChange)
            this.props.onChange(event);
    };
    /*
    handleChange(event) {

        this.setState({ value: event.target.value });
        if (this.props.onChange)
            this.props.onChange(event);
    }
    */
    render() {

        return (
            <div>
                <Label for="">{this.state.placeholder}</Label>
                    <InputGroup
                        className={
                        "input-lg" + (this.state.isFocus ? " input-group-focus" : "") + (this.state.invalid ? " input-group-focus" : "")
                        }
                        style={{padding:'0'}}
                    >
                    <InputGroupAddon addonType="prepend" >
                            <InputGroupText style={{ borderRadius:'0', padding:'15px 10px'}}>
                            <i className={((this.state.icon != null && this.state.icon != '' ) ? this.state.icon : "now-ui-icons users_circle-08")}></i>
                            </InputGroupText>
                    </InputGroupAddon>
                    <Input
                        style={{ borderRadius: '0', fontSize: this.state.fontSize, background: this.state.background }}
                        name={this.state.name}
                        placeholder={this.state.placeholder}
                        type={this.state.type}
                        maxLength={this.state.maxLength}
                        onFocus={() => this.setFocus(true)}
                        onBlur={() => this.setFocus(false)}
                        value={this.state.value}
                        onChange={this.handleChange}
                        invalid={this.state.invalid}
                        readOnly={this.state.isReadOnly}
                        //onChange={e => this.setVal(e.target.value)}
                        //onChange={() => this.handleChange}
                        ></Input>
                    </InputGroup>
                </div>
        );
    }
}
export default TSText;